type ErrorMessage = string | string[];

/** Quiet background readers handle unavailable content in their own interface. */
export const createGraphQLErrorNotifier =
    (context: Record<string, unknown>, notify: (message: ErrorMessage) => void) =>
    (message: ErrorMessage) => {
        if (context.suppressGlobalErrorToast !== true) {
            notify(message);
        }
    };
